import { gql } from '@urql/core'
import { AuthorInfo, Blog } from 'entities/blog'
import { Tag } from 'entities/tag'
import { StandardVertical } from 'entities/vertical'
import { BlogCardData, FRAGMENT_BLOG_CARD } from 'containers/blogs/components/BlogCard'
import {
    FRAGMENT_JOB_CARD_SMALL,
    JobCardSmallData,
} from 'containers/blogs/components/job/JobCardSmall'

export type BlogForBlogPage = Pick<
    Blog,
    | 'id'
    | 'title'
    | 'feature'
    | 'readingTime'
    | 'creationDate'
    | 'published'
    | 'body'
    | 'author'
    | 'primaryVertical'
    | 'originalSource'
    | 'updated'
    | 'upvoteCount'
    | 'creatorId'
> & {
    authorInfo: Pick<AuthorInfo, 'id' | 'name' | 'imageUrl' | 'summary'>
    tags: Pick<Tag, 'id' | 'label' | 'slug' | 'weight'>[]
}

export type BlogForBlogPageExtended = BlogForBlogPage & {
    seoDescription: string
    bodyHtml: string
}

export const QUERY_BLOG = gql<{ blog: BlogForBlogPage }, { id: string }>`
    query blog($id: ID!) {
        blog(id: $id) {
            id
            title
            feature
            readingTime
            creationDate
            published
            body
            authorInfo {
                id
                name
                imageUrl
                summary
            }
            author
            tags {
                id
                label
                slug
                weight
            }
            primaryVertical
            originalSource
            updated
            upvoteCount
            creatorId
        }
    }
`

export const QUERY_RECOMMENDED_ENTITIES = gql<
    { jobs: JobCardSmallData[]; blogs: { blogs: BlogCardData[] } },
    {
        id: string
        pageSizeJobs: number
        pageSizeBlogs: number
        vertical: StandardVertical
    }
>`
    query recommended_entities(
        $id: ID
        $vertical: vertical
        $pageSizeJobs: Int
        $pageSizeBlogs: Int
    ) {
        jobs(
            filter_type: "recommended"
            entity_id: $id
            entity_type: "blog"
            page_size: $pageSizeJobs
            page_number: 1
        ) {
            ...JobCardSmall
        }
        blogs(page_size: $pageSizeBlogs, page_number: 1, vertical: $vertical) {
            blogs {
                ...BlogCard
            }
        }
    }
    ${FRAGMENT_BLOG_CARD}
    ${FRAGMENT_JOB_CARD_SMALL}
`
